import React from "react";
import Box from "react-raster";
import styled from "styled-components";
import Container from "../Container";
import { H3, Blockquote, AccentTitle } from "../Typography";

const BlockquoteContainer = styled.div`
  margin-left: 30px;
  padding-top: 40px;
`;

const FullWidthWrapper = styled.div`
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

function NoImage({ title, name, quote, hasBottomMargin, hasTopMargin }) {
  return (
    <FullWidthWrapper
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container>
        <Box cols={[6, 10, 12]}>
          <H3>{title}</H3>
          <BlockquoteContainer>
            <Blockquote large>{quote}</Blockquote>
          </BlockquoteContainer>
          {name && <AccentTitle>{name}</AccentTitle>}
        </Box>
      </Container>
    </FullWidthWrapper>
  );
}

export default NoImage;
